var _defs, _rect, _rect2, _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesVectorBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wave-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#053b84",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#053b84",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 0 L 0 0 0 60",
    fill: "none",
    stroke: "#053b84",
    strokeOpacity: 0.04,
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#bg-grad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#grid)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "15%",
    cy: "25%",
    r: 300,
    fill: "#053b84",
    opacity: 0.04,
    filter: "blur(40px)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "85%",
    cy: "75%",
    r: 400,
    fill: "#053b84",
    opacity: 0.03,
    filter: "blur(60px)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,300 C320,100 420,500 720,300 C1020,100 1120,500 1440,300 L1440,800 L0,800 Z",
    fill: "url(#wave-grad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,600 C320,400 420,800 720,600 C1020,400 1120,800 1440,600 L1440,800 L0,800 Z",
    fill: "url(#wave-grad)",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,200 C400,400 400,-100 800,100 C1200,300 1200,0 1440,100 L1440,0 L0,0 Z",
    fill: "url(#wave-grad)",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesVectorBg);
export default __webpack_public_path__ + "static/media/services-vector-bg.263276262596febf8ce9b4a9b4d272d0.svg";
export { ForwardRef as ReactComponent };